import React, { useMemo } from 'react'

import Tabs from '@/components/Tabs/Tabs'

import { InputSelect } from '../styled'
import { FormContext, type FormInputType } from '../types'

const FormInputSelectTab: React.FC<{
  input: FormInputType & { type: 'select-tab' }
}> = ({ input }) => {
  type LabelType = (typeof input)['options'][number]['label']

  const { name: inputName, initialValue, options, onChange: inputOnChange } = input

  const { submitting, onChange } = React.useContext(FormContext)

  const initialOption = useMemo(
    () => options.find(option => option.value === initialValue),
    [options, initialValue]
  )

  const [currentTab, setCurrentTab] = React.useState<LabelType | null>(initialOption?.label ?? null)
  const tabOptions = useMemo(() => options.map(option => option.label), [options])

  const handleChange = React.useCallback(
    (label: LabelType) => {
      if (submitting) {
        // No op when form is locked
        return
      }

      const selectedTab = options.find(option => option.label === label) ?? null

      setCurrentTab(selectedTab?.label ?? null)
      onChange(inputName, selectedTab?.value ?? null)
      inputOnChange?.(selectedTab?.value ?? null)
    },
    [submitting, onChange, inputName, options, inputOnChange]
  )

  return (
    <InputSelect>
      <Tabs
        variant="rounded"
        tabs={tabOptions}
        currentTab={currentTab}
        onTabChange={handleChange}
        buttonProps={{
          minWidth: 0,
          flex: 1,
          p: { base: '2px', sm: 'auto' },
        }}
      />
    </InputSelect>
  )
}

export default FormInputSelectTab
